import { createSelector } from '@ngrx/store';

import { JobsBriefSelectors } from './jobs/jobs-brief.store';
import { TalentPoolsBriefSelectors } from './talent-pools/talent-pools-brief.store';

const active = createSelector(
  JobsBriefSelectors.active,
  TalentPoolsBriefSelectors.active,
  (jobs, talentPools) => [...jobs, ...talentPools],
);
const archived = createSelector(
  JobsBriefSelectors.archived,
  TalentPoolsBriefSelectors.archived,
  (jobs, talentPools) => [...jobs, ...talentPools],
);
const all = createSelector(
  JobsBriefSelectors.all,
  TalentPoolsBriefSelectors.all,
  (jobs, talentPools) => [...jobs, ...talentPools],
);
const activeScopeIsLoaded = createSelector(
  JobsBriefSelectors.activeScopeIsLoaded,
  TalentPoolsBriefSelectors.activeScopeIsLoaded,
  (jobsLoaded, talentPoolsLoaded) => jobsLoaded && talentPoolsLoaded,
);

const selectors = {
  all,
  active,
  archived,
  activeScopeIsLoaded,
};

export { selectors as OffersBriefSelectors };
